import { useState } from 'react';
import {
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Media,
    Collapse,
    Input,
    TabPane,
} from "reactstrap"
import { Link } from "react-router-dom";
import '../../components/Common/Common.css';
import { useDispatch, useSelector } from "react-redux";

import {
    setAdmMemberActivityContactsLog,
    setAdmMemberActivityEntitiesStarHideLog
} from "../../store/actions";

import ContactsLogModal from './ContactsLogModal';
import EntitiesStarHideLogModel from './EntitiesStarHideLogModel';
import WeCrestPagination from '../../components/WeCrestPagination';
import PeriodBtn from '../../components/Filter/PeriodBtn';

const thBaseStyle = { display: 'flex', alignItems: "center", justifyContent: "center", gap: "3px" };

const columns = [
    { label: "Username", isSortable: true, sortAsc: "ORA", sortDesc: "ORD", thSyle: thBaseStyle },
    { label: "Login", isSortable: true, sortAsc: "UNA", sortDesc: "UND", thSyle: { ...thBaseStyle, maxWidth: "220px" } },
    { label: "Login date time", isSortable: true, sortAsc: "SUA", sortDesc: "SUD", thSyle: thBaseStyle },
    { label: "Contacts added", isSortable: true, sortAsc: "JNA", sortDesc: "JND", thSyle: thBaseStyle },
    { label: "Contacts deleted", isSortable: true, sortAsc: "ATA", sortDesc: "ATD", thSyle: thBaseStyle },
    { label: "Starred entities", isSortable: true, sortAsc: "ATA", sortDesc: "ATD", thSyle: thBaseStyle },
    { label: "Hidden entities", isSortable: true, sortAsc: "ATA", sortDesc: "ATD", thSyle: thBaseStyle },
]

function MemberActivity({ activeTab, tabId, filterValidation }) {

    const dispatch = useDispatch();
    const { noticeStr, activityList, totalPage } = useSelector(state => ({
        totalPage: state.admMemberStatistics.activityTotalPage,
        noticeStr: state.admMemberStatistics.activityNoticeStr,
        activityList: state.admMemberStatistics.activityList,
    }))

    // Form open toggle
    const [isOpen, setIsOpen] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen);
    }

    // Contacts log open toggle
    const [isContactLogOpen, setIsContactLogOpen] = useState(false);
    
    const toggleContactLog = (info, submitType) => {
        if (info != null) {
            filterValidation.setFieldValue("activity", info);
            filterValidation.setFieldValue("submitType", submitType);
            filterValidation.handleSubmit(filterValidation.values)
        } else {
            filterValidation.setFieldValue("activity", null);
            dispatch(setAdmMemberActivityContactsLog({ contactsLog: [], contactsLogActive: [], contactsLogTotalPage: 1 }));
        }
        setIsContactLogOpen(!isContactLogOpen);
    }

    // Entities star/hide log open toggle
    const [isEntitiesStarHideLogOpen, setIsEntitiesStarHideLogOpen] = useState(false);

    const toggleEntitiesStarHideLog = (info, submitType) => {
        if (info != null) {
            filterValidation.setFieldValue("activity", info);
            filterValidation.setFieldValue("submitType", submitType);
            filterValidation.handleSubmit(filterValidation.values)
        } else {
            filterValidation.setFieldValue("activity", null);
            dispatch(setAdmMemberActivityEntitiesStarHideLog({ entitiesStarHideLog: [], entitiesStarHideLogActive: [], entitiesStarHideLogTotalPage: 1 }));
        }
        setIsEntitiesStarHideLogOpen(!isEntitiesStarHideLogOpen);
    }

    const [curPageInput, setCurPageInput] = useState(1);
    const onPageChange = (sortType, curPage, perPage) => {
        filterValidation.setFieldValue("submitType", "view");

        if (curPage) {
            // setCurPageInput(curPage);
            filterValidation.setFieldValue("curPageAct", curPage);
        } else {
            // setCurPageInput(1);
            filterValidation.setFieldValue("curPageAct", 1);
        }

        if (perPage) {
            filterValidation.setFieldValue("perPageAct", perPage);
        }

        filterValidation.handleSubmit(filterValidation.values);
    }

    return (
        <TabPane style={activeTab === tabId ? { display: "block" } : { display: "none" }} tabId={tabId}>
            <Row>
                <Col lg={12}>
                    <Card>
                        <Link onClick={toggle} className="text-dark" to="#">
                            <div className="p-4">
                                <Media className="d-flex align-items-center">
                                    <div className="flex-shrink-0 me-3">
                                        <i className="uil uil-list-ul text-primary h2"></i>
                                    </div>
                                    <div className="flex-grow-1 overflow-hidden">
                                        <h5 className="font-size-16 mb-1">Member Activity</h5>
                                        {/* <p className="text-muted mb-0">
                                            Use this tool to view member statistics on system usage based on the selected criteria.
                                            <br />Note: The selected From Date / To Date applies only to filtering subscription start dates.
                                            <span className='text-danger'> It does not affect the calculation of statistics such as Cases uploaded, Cases contacted, Emails sent, or Send rate. </span>
                                            These statistics are calculated daily based on a fixed reporting window of the past 2 months.
                                        </p> */}
                                    </div>
                                    <i className="uil uil-filter font-size-24 text-muted"></i>
                                </Media>
                            </div>
                        </Link>
                        <Collapse isOpen={isOpen}>
                            <div className="p-4 border-top">
                                <Row className="mb-3">
                                    <label
                                        htmlFor="activityMember"
                                        className="col-md-2 col-form-label"
                                    >
                                        Member *
                                    </label>
                                    <div className="col-md-3">
                                        <Input
                                            className="form-control"
                                            type="text"
                                            placeholder="Member"
                                            id="activityMember"
                                            name="activityMember"
                                            onChange={filterValidation.handleChange}
                                            value={filterValidation.values.activityMember}
                                        />
                                    </div>
                                </Row>
                                <Row>
                                    <label htmlFor="inscribedDate" className="col-md-2 col-form-label" style={{ paddingTop: '0px' }}>
                                        Login date
                                    </label>
                                    <div className="col-md-10">
                                        <PeriodBtn
                                            filterName="memberActivity"
                                            formik={filterValidation}
                                        />
                                    </div>
                                </Row>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="contact"
                                        className="col-md-2 col-form-label"
                                    >
                                        Contact
                                    </label>
                                    <div className="col-md-3">
                                        <Input
                                            className="form-control"
                                            type="text"
                                            placeholder="Email address"
                                            id="contact"
                                            name="contact"
                                            onChange={filterValidation.handleChange}
                                            value={filterValidation.values.contact}
                                        />
                                    </div>
                                </Row>
                                <Row >
                                    <Col md={2}>&nbsp;</Col>
                                    <Col md={3}>&nbsp;</Col>
                                    <Col md={3}>
                                        <button
                                            type="button"
                                            className="btn btn-primary waves-effect waves-light col-md-5"
                                            onClick={() => {
                                                filterValidation.setFieldValue("submitType", "view");
                                                filterValidation.handleSubmit(filterValidation.values);
                                            }}
                                        >
                                            Search
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                        </Collapse>
                    </Card>
                </Col>
            </Row>
            {
                (!activityList || (Array.isArray(activityList) && activityList.length == 0)) && noticeStr &&
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardBody>
                                <CardTitle className="text-muted mb-0">
                                    <p style={{ whiteSpace: "pre" }}>
                                        {noticeStr}
                                    </p>
                                </CardTitle>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            }
            {
                Array.isArray(activityList) && activityList.length > 0 &&
                <Row>
                    <Col lg={12}>
                        <Card>
                            <CardTitle className="text-muted mt-3" style={{ paddingLeft: "25px" }}>
                                <span>
                                    {noticeStr}
                                </span>
                            </CardTitle>
                            <CardBody>
                                <div className="table-responsive" style={{marginBottom: "20px"}}>
                                    <Table className="table mb-0">
                                        <thead>
                                            <tr>
                                                {
                                                    columns.map(col => {
                                                        return (
                                                            <th key={col.label}>
                                                                <div style={col.thSyle}>
                                                                    <span>{col.label}</span>
                                                                    {/* <span style={{ display: 'flex', flexDirection: "column", gap: "3px", justifyContent: "center", alignItems: "center" }}>
                                                                        <Link
                                                                            to='#'
                                                                            onClick={() => {
                                                                                filterValidation.setFieldValue("sort", col.sortAsc)
                                                                                filterValidation.setFieldValue("submitType", "view")
                                                                                filterValidation.handleSubmit(filterValidation.values)
                                                                                console.log(filterValidation)
                                                                            }}
                                                                            className={filterValidation.values.sort == col.sortAsc ? "text-danger" : ""}
                                                                        >
                                                                            <i className="uil uil-angle-up font-size-18"></i>
                                                                        </Link>
                                                                        <Link
                                                                            to='#'
                                                                            onClick={() => {
                                                                                filterValidation.setFieldValue("sort", col.sortDesc)
                                                                                filterValidation.setFieldValue("submitType", "view")
                                                                                filterValidation.handleSubmit(filterValidation.values)
                                                                                console.log(filterValidation)
                                                                            }}
                                                                            className={filterValidation.values.sort == col.sortDesc ? "text-danger" : ""}
                                                                        >
                                                                            <i className="uil uil-angle-down font-size-18"></i>
                                                                        </Link>
                                                                    </span> */}
                                                                </div>
                                                            </th>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                activityList.map((info, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.username}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.loginUsername}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>{info.loginDate}</td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                <span
                                                                    style={info.contactsAdded > 0 ? { cursor: "pointer" } : {}}
                                                                    className={info.contactsAdded > 0 ? "text-primary" : ""}
                                                                    onClick={() => {
                                                                        if (info.contactsAdded > 0) {
                                                                            toggleContactLog(info, "viewAddedContactLog")
                                                                        }
                                                                    }}
                                                                >
                                                                    {info.contactsAdded}
                                                                </span>
                                                            </td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                <span
                                                                    style={info.contactsDeleted > 0 ? { cursor: "pointer" } : {}}
                                                                    className={info.contactsDeleted > 0 ? "text-primary" : ""}
                                                                    onClick={() => {
                                                                        if (info.contactsDeleted > 0) {
                                                                            toggleContactLog(info, "viewDeletedContactLog")
                                                                        }
                                                                    }}
                                                                >
                                                                    {info.contactsDeleted}
                                                                </span>
                                                            </td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                <span
                                                                    style={info.entitiesStarred > 0 ? { cursor: "pointer" } : {}}
                                                                    className={info.entitiesStarred > 0 ? "text-primary" : ""}
                                                                    onClick={() => {
                                                                        if (info.entitiesStarred > 0) {
                                                                            toggleEntitiesStarHideLog(info, "viewEntitiesStarLog")
                                                                        }
                                                                    }}
                                                                >
                                                                    {info.entitiesStarred}
                                                                </span>
                                                            </td>
                                                            <td style={{ verticalAlign: "middle", textAlign: "center" }}>
                                                                <span
                                                                    style={info.entitiesHidden > 0 ? { cursor: "pointer" } : {}}
                                                                    className={info.entitiesHidden > 0 ? "text-primary" : ""}
                                                                    onClick={() => {
                                                                        if (info.entitiesHidden > 0) {
                                                                            toggleEntitiesStarHideLog(info, "viewEntitiesHideLog")
                                                                        }
                                                                    }}
                                                                >
                                                                    {info.entitiesHidden}
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>
                                </div>
                                <WeCrestPagination
                                    viewList={onPageChange}
                                    pageSize={filterValidation.values.perPageAct}
                                    curPage={filterValidation.values.curPageAct}
                                    totalPage={totalPage}
                                    curPageInput={curPageInput}
                                    setCurPageInput={setCurPageInput}
                                    pageSizeList={[10, 20, 30, 40, 50]}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            }

            <ContactsLogModal
                toggleContactLog={toggleContactLog}
                isContactLogOpen={isContactLogOpen}
                filterValidation={filterValidation}
            />

            <EntitiesStarHideLogModel
                toggleEntitiesStarHideLog={toggleEntitiesStarHideLog}
                isEntitiesStarHideLogOpen={isEntitiesStarHideLogOpen}
                filterValidation={filterValidation}
            />

        </TabPane>
    )

}


export default MemberActivity;